// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockContent-module--wrapper--fa5bd"};